const tab_sections = {
    overview: 'Обзор',
    authentication: 'Аутентификация',
    authorization: 'Авторизация',
    users: 'Пользователи',
    developer: 'Разработчик',
    tenant: 'Арендатор',
};
export default Object.freeze(tab_sections);
